import React from 'react';
import { ChevronUpIcon as HeroChevronUpIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type ChevronUpIconProps = Omit<IconProps, 'children'>;

export const ChevronUpIcon: React.FC<ChevronUpIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroChevronUpIcon />
        </Icon>
    );
};
